<template>
  <article
    class="transaction-negociate card"
    :class="{ 'transaction-negociate--sell': selling }"
    >
    <CardTab
      around
      v-model="tab"
      :items="tabs"
      />

    <div class="card__body">
      <p class="transaction-negociate__title">Saldo disponível</p>
      <p class="transaction-negociate__balance" v-text="coin.formated"></p>

      <AppSwitch
        v-model="selected"
        :options="switches"
        />

      <div class="transaction-negociate__percent" v-if="selected === 0">
        <p class="transaction-negociate__percent-title">Selecione o % do saldo:</p>

        <div class="transaction-negociate__percent-options">
          <button
            :key="percent"
            v-for="percent in percents"
            @click.prevent="update(percent)"
            class="transaction-negociate__percent-option"
            :class="{ 'transaction-negociate__percent-option--active': percent_selected === percent && ! dirty }"
            >
            {{ percent }}%
          </button>
        </div>
      </div>

      <div class="transaction-negociate__input" v-if="selected === 1">
        <Money
          v-bind="money"
          v-model="value"
          class="transaction-negociate__input-control"
          />

        <span class="transaction-negociate__input-sufix">Reais</span>
      </div>

      <div class="transaction-negociate__input" v-if="selected === 2">
        <Money
          :value="0"
          v-bind="money"
          class="transaction-negociate__input-control"
          />

        <input
          placeholder="Quantidade"
          class="transaction-negociate__input-control"
          />
      </div>

      <div class="transaction-negociate__input transaction-negociate__input--switch">
        <Money
          v-bind="money"
          v-model="value"
          class="transaction-negociate__input-control"
          />

        <button class="transaction-negociate__input-switch">
          <TransactionArrow />
        </button>

        <span class="transaction-negociate__input-sufix">Reais</span>
      </div>

      <p class="transaction-negociate__item">
        Quantidade
        <span class="transaction-negociate__item-value">280</span>
      </p>

      <p class="transaction-negociate__item transaction-negociate__item--border">
        Taxa
        <span class="transaction-negociate__item-value">R$ 34,90</span>
      </p>

      <p class="transaction-negociate__item transaction-negociate__item--highlight">
        Total Líquido
        <span class="transaction-negociate__item-value" v-text="formated"></span>
      </p>

      <button class="transaction-negociate__buy" @click.prevent="create">{{ buying ? 'Comprar' : 'Vender' }} {{ coin.title }}</button>
    </div>
  </article>
</template>

<script>
  import { Money } from 'v-money';
  import { mapGetters } from 'vuex';
  import { format } from '@/helpers';
  import AppSwitch from '@/components/Switch';
  import CardTab from '@/components/Card/Tab';
  import TransactionArrow from '@/assets/transaction-arrow.svg';

  export default {
    components: {
      Money,
      CardTab,
      AppSwitch,
      TransactionArrow,
    },

    props: {
      pro: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    data: () => ({
      tab: 0,
      value: 0,
      selected: 0,
      dirty: false,
      percent_selected: 0,
    }),

    /**
     * Order matters.
     */
    watch: {
      value () {
        this.dirty = true;
      },

      percent_selected () {
        this.dirty = false;
      },
    },

    computed: {
      ...mapGetters('coins', [
        'coin',
      ]),

      formated () {
        return format(this.value);
      },

      money () {
        return {
          decimal: ',',
          precision: 2,
          masked: false,
          prefix: 'R$ ',
          thousands: '.',
        };
      },

      percents () {
        return [
          25, 50, 100,
        ];
      },

      switches () {
        const options = [
          'A mercado', 'Limitada',
        ];

        if (this.pro) {
          options.push('Stop');
        }

        return options;
      },

      tabs () {
        return [
          'Compra', 'Venda',
        ];
      },

      buying () {
        return this.tab === 0;
      },

      selling () {
        return this.tab === 1;
      },
    },

    methods: {
      update (percent) {
        this.percent_selected = percent;
        this.value = this.coin.total / 100 * (percent / 100);
      },

      create () {
        if (! this.value) {
          return;
        }

        this.$emit('transaction', {
          id: Date.now(),
          price: this.value,
          sell: this.selling,
          coin: this.coin.title,
          initial: this.coin.initial,
          type: this.switches[this.selected],
        });
      },
    },
  };
</script>

<style lang="scss">
  .transaction-negociate {
    &__title {
      font-size: 14px;
      color: #b2b8c5;
      text-align: center;
      margin-bottom: 8px;
      letter-spacing: 0.28px;
    }

    &__balance {
      font-size: 32px;
      color: #ffffff;
      font-weight: 500;
      text-align: center;
      margin-bottom: 24px;
      letter-spacing: 0.64px;
    }

    &__percent {
      display: flex;
      align-items: center;
      margin-bottom: 42px;
      justify-content: space-between;

      &-title {
        font-size: 14px;
        color: #b2b8c5;
        letter-spacing: 0.28px;
      }

      &-options {
        display: flex;
        font-size: 14px;
        font-weight: 500;
      }

      &-option {
        height: 26px;
        padding: 0 8px;
        color: #ffffff;
        border-radius: 4px;
        border: solid 1px #ffffff;

        &--active {
          color: #3e388b;
          background: #FFF !important;
        }

        &:hover {
          background-color: rgba(#FFF, .1);
        }

        &:not(:last-of-type) {
          margin-right: 8px;
        }
      }
    }

    &__input {
      display: flex;
      font-size: 13px;
      color: #ffffff;
      line-height: 1.08;
      position: relative;
      margin-bottom: 24px;
      letter-spacing: 0.26px;

      &--switch & {
        &-control {
          border-right: 0;
          padding-right: 32px;
          border-radius: 4px 0 0 4px;
        }

        &-sufix {
          right: 61px;
        }
      }

      &-control {
        flex: 1;
        min-width: 0;
        background: none;
        color: #ffffff;
        padding: 14px 16px;
        border-radius: 4px;
        border: solid 1px #b9b9b9;

        &:not(:first-child) {
          margin-left: 16px;
        }
      }

      &-switch {
        width: 44px;
        background-color: #8e95a9;
        border-radius: 0 4px 4px 0;

        &:hover {
          background-color: #68769e;
        }
      }

      &-sufix {
        top: 0;
        bottom: 0;
        right: 16px;
        display: flex;
        position: absolute;
        align-items: center;
      }
    }

    &__item {
      display: flex;
      color: #8e95a9;
      margin-bottom: 16px;
      align-items: center;
      letter-spacing: 0.32px;
      justify-content: space-between;

      $item: &;

      &--border {
        padding-bottom: 8px;
        border-bottom: 1px solid #939cac;
      }

      &--highlight {
        color: #b2b8c5;

        #{$item}-value {
          opacity: 1;
          line-height: 1;
          font-weight: 600;
        }
      }

      &-value {
        opacity: .8;
        color: #FFF;
      }
    }

    &__buy {
      width: 100%;
      height: 44px;
      margin-top: 8px;
      color: #ffffff;
      line-height: 1.13;
      transition: 250ms;
      border-radius: 4px;
      letter-spacing: 0.86px;
      background-color: #509e02;

      &:hover {
        background-color: #448700;
      }
    }

    .card-tab {
      &__item {
        margin: 0;

        &-link {
          width: 120px;
        }

        &--active .card-tab__item-link {
          color: #60c100;
        }
      }

      &__border {
        background-color: #60c100;
      }
    }

    &--sell &__buy {
      background-color: #ff011f;

      &:hover {
        background-color: #d0021b;
      }
    }

    &--sell .card-tab {
      &__item--active .card-tab__item-link {
        color: #ff011f;
      }

      &__border {
        background-color: #ff011f;
      }
    }
  }
</style>
